/* eslint-disable react/jsx-key */
/* eslint-disable react/prop-types */
import React from 'react';
import Loading from '../../components/Loading';
import CodeIcon from '@mui/icons-material/Code';
import ArchiveIcon from '@mui/icons-material/Archive';
import GroupIcon from '@mui/icons-material/Group';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { useNavigate } from 'react-router-dom';
import { formatNumber } from '../../utils';

export const CardContainer = ({ cardInfo, loading }) => {
  const iconMap = {
    CodeIcon: <CodeIcon className="h-5 w-5 text-blue-500" />,
    ArchiveIcon: <ArchiveIcon className="h-5 w-5 text-blue-500" />,
    UsersIcon: <GroupIcon className="h-5 w-5 text-blue-500" />,
    CubeIcon: <WidgetsIcon className="h-5 w-5 text-blue-500" />
  };

  const navigate = useNavigate();

  const handleClick = url => {
    navigate(url);
  };

  const renderIcon = iconName => {
    return iconMap[iconName] || null;
  };

  return (
    <div className="grid pt-6 w-full grid-cols-1 gap-3 md:grid-cols-2 md:gap-3 xl:grid-cols-5 2xl:gap-3.5">
      {cardInfo.map(card => {
        return (
          <div className="rounded-sm border border-stroke bg-white px-7.5 py-6 shadow-default dark:border-strokedark dark:bg-boxdark">
            {loading ? (
              <Loading type="card" />
            ) : (
              <>
                <div className="flex h-11.5 w-11.5 items-center justify-center rounded-full bg-meta-2 dark:bg-meta-4">
                  <div className="icon">{renderIcon(card.icon)}</div>
                </div>

                <div className="mt-4 flex items-end justify-between">
                  <div>
                    <h4 className="text-title-md font-bold text-black dark:text-white">
                      {formatNumber(card.count)}
                    </h4>
                    <span className="text-sm font-medium text-slate-600 dark:text-slate-300">
                      {card.url ? (
                        <span
                          onClick={() => {
                            handleClick(card.url);
                          }}
                          className="cursor-pointer text-blue-500 transition-colors hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300"
                        >
                          {card.label}
                        </span>
                      ) : (
                        card.label
                      )}
                    </span>
                  </div>

                  <span className="flex items-center gap-1 text-sm font-medium text-meta-3">
                    -
                  </span>
                </div>
                <span className="flex items-center gap-1 text-xs font-medium text-meta-3">
                  <span className="text-slate-500 dark:text-slate-400">
                    {card.infoLabel ? card.infoLabel + ':' : ''}
                  </span>
                  <span className="text-slate-700 dark:text-slate-200">
                    {card.info}
                  </span>
                </span>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};
